module.exports = __webpack_public_path__ + "img/download.ea9f4609.png";